<flash-messages></flash-messages>
<div class="attendee-header">
    <ccl-custom-page [model]="headerConfig.template.pages['landing']"></ccl-custom-page>
    <div class="login-button" (clickOutside)="toggleProfileDropdown = false">
        <button
            id="login-label"
            class="c-btn c-btn--primary login-footer-button-primary"
            (click)="openPopup('login')"
            *ngIf="this.sharedService.loggedInAttendee == null && this.loginConfig['isEnabled'] == true && !loginConfig.disablePublicView && ((this.loginConfig.body.isFormLogin == true || !this.loginConfig.body.hasOwnProperty('isFormLogin')) || (this.loginConfig.body.isFormLogin == false && this.loginConfig.body.ssoConfigs.length > 1 && this.loginConfig.body.isSSOEnabled))"
        >
        {{ 'catalog_section.login' | translate }}
        </button>
        <span *ngIf="this.sharedService.loggedInAttendee == null && this.loginConfig['isEnabled'] == true && this.loginConfig.body.ssoConfigs.length == 1 && this.loginConfig.body.isSSOEnabled && this.loginConfig.body.isFormLogin == false && !loginConfig.disablePublicView">
        <button
            class="c-btn c-btn--primary"
            [ngStyle]="{
                'background-color': loginConfig.footer.button.primary.background,
                color: loginConfig.footer.button.primary.color
            }"
            *ngFor="let ssoConfig of loginConfig.body.ssoConfigs"
            [ngClass]="ssoConfig.ssoAccountConfig.buttonConfig.buttonClass"
            (click)="loginWithSSO(ssoConfig.ssoAccountConfig.ssoConfig.id)"
            >
            <img
            role="presentation"
            src="{{ ssoConfig.ssoAccountConfig.buttonConfig.buttonIcon }}"
            />
            {{ ssoConfig.ssoAccountConfig.buttonConfig.buttonLabel }}
        </button>
        <form
            id="ssoForm"
            enctype="multipart/form-data"
            method="post"
            action=""
            role="form"
            class="form-inline"
            encoding="multipart/form-data"
        ></form>
        </span>
        <span [title]="toggleProfileDropdown ? 'Close Profile Menu' : 'Open Profile Menu'"
            *ngIf="this.sharedService.loggedInAttendee != null"
            (cclClick)="toggleProfileDropdown = !toggleProfileDropdown"
        >
            <img alt="User Avatar" [src]="sharedService.loggedInAttendee.profile.avatarThumbnail" />

            <i role="presentation" class="fa fa-sort-down"></i>
        </span>
        <div class="profile-dropdown" *ngIf="this.sharedService.loggedInAttendee != null && toggleProfileDropdown">
            <ul>
                <li>
                    <span>{{ sharedService.loggedInAttendee.profile.firstName }}</span>&nbsp;<span
                        >{{ sharedService.loggedInAttendee.profile.lastName }}</span
                    >
                </li>
                <li title="Logout"
                    id="logout-label"
                    class="logout-button login-footer-button-primary"
                    (cclClick)="toggleProfileDropdown = false; logout()"
                >
                {{ 'catalog_section.logout' | translate }}
                </li>
            </ul>
        </div>
    </div>
</div>
   
<div class="container-fluid" *ngIf="(this.sharedService.loggedInAttendee == null && !loginConfig.disablePublicView) || this.sharedService.loggedInAttendee != null">
    <div
        class="center-section row"
        [ngClass]="{ 'top-filter': sharedService.catalogLayoutConfig.filterPlacement == 'top' }"
    >
    
        <!-- FILTER SECTION -->
        <div
        [hidden]="filterConfig.isFilterEnabled == false"
            [ngClass]="{
                'cart-backdrop': showSideBar
            }"
            (click)="toggleSideBar()"
        ></div>
        <div
            [hidden]="filterConfig.isFilterEnabled == false"
            [ngClass]="{
                sidebar:
                    sharedService.catalogLayoutConfig.filterPlacement == 'left' ||
                    sharedService.catalogLayoutConfig.filterPlacement == 'slider',
                floating: sharedService.catalogLayoutConfig.filterPlacement == 'slider',
                closed: !showSideBar
            }"
        >
            <div class="attendee-filter" [focusTrap]="showSideBar">
                <filter-section [hidden]="!showSideBar && sharedService.catalogLayoutConfig.filterPlacement == 'slider'" [filterPlacement]="sharedService.catalogLayoutConfig.filterPlacement"></filter-section>
                <span title="Filter"
                    *ngIf="sharedService.catalogLayoutConfig.filterPlacement == 'slider'"
                    class="close filter-slider-toggle"
                    (cclClick)="toggleSideBar()"
                ></span>
            </div>
        </div>
        <!-- FILTER SECTION -->
        <!-- CART SECTION -->
        <div [hidden]="this.sharedService.loggedInAttendee != null && loginConfig.restrictedBrowsing == true && (mysessionConfig.isSessionEnabled == true || !mysessionConfig.hasOwnProperty('isSessionEnabled'))"
            [ngClass]="{
                'cart-backdrop': showCart
            }"
            (click)="toggleCart()"
        ></div>
        <div [hidden]="this.sharedService.loggedInAttendee != null && loginConfig.restrictedBrowsing == true"
            class="attendee-cart floating"
            [ngClass]="{
                closed: !showCart
            }"
            *ngIf="this.sharedService.loggedInAttendee != null && (mysessionConfig.isSessionEnabled == true || !mysessionConfig.hasOwnProperty('isSessionEnabled'))"
        >
            <div [focusTrap]="showCart">
                <cart-section [hidden]="!showCart"></cart-section>
                <span title="My Sessions" class="close my-session-drawer" (cclClick)="toggleCart()"
                    ><i role="presentation" class="fa fa-lg" [ngClass]="drawerControlConfig.icon" title="Cart"></i
                ></span>
            </div>
            <!-- <div class="cart-section" (click)="openDrawer('cart', $event)"></div> -->
        </div>

        <!-- CART SECTION -->
        <!-- Myschedule SECTION -->
        <div 
            [ngClass]="{
                'cart-backdrop': showMySchedule
            }"
            (click)="toggleMySchedule()"
            *ngIf="(mysessionConfig.hasOwnProperty('my_schedule') && mysessionConfig.my_schedule.isScheduledEnabled==true) || !mysessionConfig.hasOwnProperty('my_schedule')"
        ></div>
        <div
            class="my-schedule floating"
            [ngClass]="{
                closed: !showMySchedule
            }"
            *ngIf="(this.sharedService.loggedInAttendee != null && mysessionConfig.hasOwnProperty('my_schedule') && mysessionConfig.my_schedule.isScheduledEnabled == true) || (this.sharedService.loggedInAttendee != null && !mysessionConfig.hasOwnProperty('my_schedule'))"
        >
            <div [focusTrap]="showMySchedule">
                <myschedule-section [hidden]="!showMySchedule"></myschedule-section>
                <span title="My Schedule"
                [ngClass]="{'close':true,'my-schedule-drawer':mysessionConfig.hasOwnProperty('my_schedule'),'my-session-drawer':!mysessionConfig.hasOwnProperty('my_schedule'),'top-25':true}" 
                (cclClick)="toggleMySchedule()"
                    ><i role="presentation" class="fa fa-lg fa-calendar" title="Schedule"></i
                ></span>
            </div>
            <!-- <div class="cart-section" (click)="openDrawer('cart', $event)"></div> -->
        </div>

        <!-- Myschedule SECTION -->

        <!-- Session Instances SECTION -->
        <div [ngClass]="{ 'cart-backdrop': showSessionInstances }" (click)="toggleSessionInstances()"></div>
        <div class="session-instances floating" [ngClass]="{ closed: !showSessionInstances }">
            <div [focusTrap]="showSessionInstances">
                <instance-section [hidden]="!showSessionInstances"></instance-section>
            </div>
        </div>
        <!-- Session Instances SECTION -->

        <div
            [ngClass]="{
                'attendee-container': true,
                'has-sidebar':
                    sharedService.catalogLayoutConfig.filterPlacement == 'left' ||
                    sharedService.catalogLayoutConfig.filterPlacement == 'slider',
                'left-sidebar': filterConfig.isFilterEnabled == false &&
                    sharedService.catalogLayoutConfig.filterPlacement == 'left'
            }"
        >
            <div class="attendee-html-top" *ngIf="htmlTopConfig.isEnabled">
                <ccl-custom-page [model]="htmlTopConfig.template.pages['landing']"></ccl-custom-page>
            </div>
            <div class="attendee-tabs" *ngIf="showTabSection"><tab-section></tab-section></div>
            <div class="active-filter-bar" *ngIf="sharedService.clearAllFilterEnabled">
                <div *ngFor="let filterKey of sharedService.objectKeys(sharedService.selectedFilterData)">
                    <div *ngIf="sharedService.selectedFilterData[filterKey] != null">
                        <div *ngFor="let filterObject of sharedService.filterData[filterKey]">
                            <div
                            *ngIf="sharedService.selectedFilterData[filterKey][filterObject.id] == true || (sharedService.selectedFilterData[filterKey][filterObject.id] == true)" class="pull-left selected-filter-item filter-header-background"
                            >
                                <span *ngIf="filterKey != 'sessionDate'; else isDate">
                                    <span *ngIf="filterObject.id != null"> {{ filterObject.name }} {{ filterObject.label }} </span>
                                    <span *ngIf="filterObject.id == null && !filterKey.includes('customField_')"> {{ filterKey }} : {{ filterObject.label }} </span>
 	                                <span *ngIf="filterObject.id == null && filterKey.includes('customField_')"> {{ filterObject.name }} {{ filterObject.label }} </span>
                                </span>
                                <ng-template #isDate>{{ filterObject.label }}</ng-template>
                                <span title="Clear Filter"
                                    class="fa fa-close"
                                    (cclClick)="clearSingleFilter(filterKey, filterObject.id)"
                                ></span>
                            </div>
                        </div>

                        <div *ngIf="sharedService.selectedFilterData[filterKey] != null && filterKey == 'sessionDate' && (!sharedService.filterData[filterKey] || (sharedService.filterData.hasOwnProperty(filterKey) && sharedService.filterData[filterKey].length == 0))">
                            <div *ngFor="let filterObject of sharedService.objectKeys(sharedService.selectedFilterData[filterKey])">
                                <div class="pull-left selected-filter-item filter-header-background">
                                    {{filterObject | date: tabConfig.dateFormat}}
                                    <span title="Clear Filter"
                                        class="fa fa-close"
                                        (cclClick)="clearSingleFilter(filterKey, filterObject.id)"
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" pull-left">
                    <span (cclClick)="clearAllFilter()" role="button" id="clear-all-label" class="clear-all-filter " title="Clear All Filters"
                        >{{ 'catalog_section.clear_all' | translate }}</span
                    >
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="session-list" id='session-section'><session-section (childEvent)="toggleSessionInstances($event)"></session-section></div>

            <div class="attendee-html-bottom" *ngIf="htmlBottomConfig.isEnabled">
                <ccl-custom-page [model]="htmlBottomConfig.template.pages['landing']"></ccl-custom-page>
            </div>
        </div>
    </div>
    <div class="speaker"></div>
</div>

<div class="container-fluid align-section" *ngIf="this.sharedService.loggedInAttendee == null && loginConfig.disablePublicView == true">
    <div class="center-section center-position row login-popup-size">
    <login-popup *ngIf="this.loginConfig['isEnabled'] == true"></login-popup>
    </div>
</div>
<div class="attendee-footer"><ccl-custom-page [model]="footerConfig.template.pages['landing']"></ccl-custom-page></div>
